import React, { useCallback, useEffect, useState } from 'react'
import { Alert, Button, Card } from '@themesberg/react-bootstrap'
import { getPublicIp } from '../../../../../helper/publicIp'

export const CurrentIpCard = ({ onIpLoaded, isSuperAdmin }) => {
  const [ip, setIp] = useState('')
  const [copied, setCopied] = useState(false)
  const [error, setError] = useState('')

  const loadIp = useCallback(async () => {
    const currentIp = await getPublicIp()
    if (!currentIp) {
      setError('Không lấy được public IP hiện tại')
      setIp('')
      if (onIpLoaded) onIpLoaded('')
      return
    }

    setIp(currentIp)
    setError('')
    if (onIpLoaded) onIpLoaded(currentIp)
  }, [onIpLoaded])

  useEffect(() => {
    loadIp()
  }, [loadIp])

  const copyIp = async () => {
    if (!ip) return
    try {
      await navigator.clipboard.writeText(ip)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch (_) {
      setError('Không copy được IP')
    }
  }

  return (
    <Card border="light" className="shadow-sm mb-4">
      <Card.Body>
        <div className="fw-bold mb-2">Public IP hiện tại</div>
        {error ? (
          <Alert variant="danger" className="mb-0">{error}</Alert>
        ) : (
          <Alert variant="info" className="mb-0 d-flex align-items-center justify-content-between flex-wrap">
            <div>
              <code className="fs-5">{ip || 'Đang tải...'}</code>
              {ip ? (
                <div className="small mt-1">
                  {isSuperAdmin
                    ? 'Thêm IP này vào whitelist bên dưới nếu cần nạp tiền.'
                    : 'Gửi IP này cho superadmin nếu cần thêm vào whitelist nạp tiền.'}
                </div>
              ) : null}
            </div>
            <Button variant="outline-dark" size="sm" className="mt-2" onClick={copyIp} disabled={!ip}>
              {copied ? 'Đã copy' : 'Copy IP'}
            </Button>
          </Alert>
        )}
      </Card.Body>
    </Card>
  )
}
